import { semanticColorLight, semanticColorDark, componentColorLight, componentColorDark, globalColorLight, globalColorDark, globalBoxShadowLight, globalBoxShadowDark, systemColorDark, systemColorLight } from './tokens/index.js';
export const getTokens = (name) => ({
    sem: {
        ...(name === 'dark' ? semanticColorDark : semanticColorLight)
    },
    cmp: {
        ...(name === 'dark' ? componentColorDark : componentColorLight)
    },
    global: {
        ...(name === 'dark' ? globalColorDark : globalColorLight),
        ...(name === 'dark' ? globalBoxShadowDark : globalBoxShadowLight)
    },
    sys: {
        ...(name === 'dark' ? systemColorDark : systemColorLight)
    }
});
//# sourceMappingURL=index.js.map